import submitWithDrafts from 'app/_shared/hook/model/submitWithDrafts'
import routeComposition from 'trait/composition/route'
import { setKey } from 'lib/util'

/**
 * Attempts to submit current pin or option model, saving it locally as a draft in case of failure.
 *
 * @param obj current module
 */
const submitPinOrOptionWithDrafts = (
  obj: Gaia.AppModule.Spec,
) => async (
  ...args: any[]
) =>{
  const type = obj[G.MODEL][G.CHILDREN]?.type?.[G.CACHE] || 'option'

  return submitWithDrafts({
    ns: 'optionManagement',
    type,
    onDeleted: obj => async (...args: any[]) => {
      const route = routeComposition(null, 'index')
      setKey(route, G.ROUTE, obj[G.STATE])

      return args
    },
  })(obj)(...args)
}

export default submitPinOrOptionWithDrafts
